// ZAMANLANMIŞ GÖREVLER — liste ve detay ekranının ORTAK sözlüğü.
//
// Zamanlama metni ("her Pazar 03:00") sunucuda TEK bir kolon olarak durmaz; sıklık + saat + günlerden
// türetilir. Backend bunu GetById/Add/Update yanıtında `scheduleText` olarak da döner, ama c360 liste
// ucu HAM ENTITY döndürdüğü için (OData) listede o alan yoktur — bu yüzden aynı türetme burada da
// yaşar. İkisi aynı kuralı uygular: ScheduledTaskScheduleCalculator.DescribeSchedule.

export const FREQUENCY = {
  ONCE: 'ONCE',
  HOURLY: 'HOURLY',
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
};

export const FREQUENCY_OPTIONS = [
  { value: FREQUENCY.ONCE, label: 'Bir kez' },
  { value: FREQUENCY.HOURLY, label: 'Saat başı' },
  { value: FREQUENCY.DAILY, label: 'Günlük' },
  { value: FREQUENCY.WEEKLY, label: 'Haftalık' },
  { value: FREQUENCY.MONTHLY, label: 'Aylık' },
];

/** 1=Pzt .. 7=Paz — rut planındaki DayNo ile AYNI eksen. */
export const WEEKDAYS = [
  { no: 1, short: 'Pzt', label: 'Pazartesi' },
  { no: 2, short: 'Sal', label: 'Salı' },
  { no: 3, short: 'Çar', label: 'Çarşamba' },
  { no: 4, short: 'Per', label: 'Perşembe' },
  { no: 5, short: 'Cum', label: 'Cuma' },
  { no: 6, short: 'Cmt', label: 'Cumartesi' },
  { no: 7, short: 'Paz', label: 'Pazar' },
];

export const RUN_STATUS_META = {
  RUNNING: { label: 'Çalışıyor', tone: 'wait' },
  SUCCESS: { label: 'Başarılı', tone: 'ok' },
  FAILED: { label: 'Hata', tone: 'bad' },
};

export const TRIGGER_LABEL = {
  SCHEDULE: 'Zamanlanmış',
  MANUAL: 'Elle',
};

/** WeekdaysJson ("[1,7]") veya weekdays dizisi → sayı dizisi. İki şekli de kabul eder. */
export function parseWeekdays(task) {
  if (Array.isArray(task?.weekdays)) return task.weekdays;
  const raw = task?.weekdaysJson ?? task?.WeekdaysJson;
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((d) => d >= 1 && d <= 7) : [];
  } catch {
    return [];
  }
}

/** "Her Pazar 03:00" gibi insan-okur zamanlama özeti. */
export function describeSchedule(task) {
  if (!task) return '—';
  const time = task.runTime || '00:00';

  switch (task.frequency) {
    case FREQUENCY.ONCE: {
      const d = task.startDate ? new Date(task.startDate) : null;
      const dateStr = d && !Number.isNaN(d.getTime()) ? d.toLocaleDateString('tr-TR') : '—';
      return `${dateStr} ${time} (bir kez)`;
    }
    case FREQUENCY.HOURLY:
      return `Her ${task.intervalN || 1} saatte bir`;
    case FREQUENCY.DAILY:
      return `Her gün ${time}`;
    case FREQUENCY.WEEKLY: {
      const days = parseWeekdays(task).sort((a, b) => a - b);
      if (days.length === 0) return 'Gün seçilmedi';
      const names = days.map((d) => WEEKDAYS[d - 1]?.label).filter(Boolean).join(', ');
      return `Her ${names} ${time}`;
    }
    case FREQUENCY.MONTHLY:
      return `Ayın ${task.monthDay || 1}. günü ${time}`;
    default:
      return '—';
  }
}
